import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultUI } from "components/pages/OneTimeACHPaymentPage";

export default function CaptureTransactionTypeDD(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "transactionTypeSelectIsActive", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage ui={ ui } />;
}